import { groupClasses } from '../';

export default function (output) {
  if (!output || !output.manages_conflict_resolution_factors) return [];

  const best = output.manages_conflict_resolution_factors.best
    ? Object.keys(output.manages_conflict_resolution_factors.best).map((b) => ({
        title: b,
        cls: groupClasses.manages,
        value: output.manages_conflict_resolution_factors.best[b]
      }))
    : [];
  const worst = output.manages_conflict_resolution_factors.worst
    ? Object.keys(output.manages_conflict_resolution_factors.worst).map(
        (b) => ({
          title: b,
          cls: groupClasses.manages,
          value: output.manages_conflict_resolution_factors.worst[b]
        })
      )
    : [];

  return [
    {
      title: 'Manages Conflict Resolution',
      value: output.manages_conflict_resolution,
      behavior_value: output.pan_result.manages_conflict_resolution_score,
      cls: groupClasses.manages,
      header: true,
      admin: true
    },
    ...best,
    ...worst
    // {
    //   title: 'Knowledge',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Skill',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Behavior',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Active Listening',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Consulting',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Negotiating',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // },
    // {
    //   title: 'Awareness',
    //   cls: groupClasses.manages,
    //   a: panResult.foobar,
    //   b: panResult.foobar
    // }
  ].map((m) => ({
    ...m,
    link:
      'https://louisianapacific.sharepoint.com/sites/LPSU/SitePages/Manages-Conflict-Resolution-Courses.aspx'
  }));
}
